// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2-TL9","label":"LabeledBox_label__1Kndq"};